import React from "react";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import AdminPartners from "./components/AdminPartners";
import PartnerOrders from "./components/PartnerOrders";
import AdminPartnerOrders from "./components/AdminPartnerOrders";
import OrderList from "./components/OrderList";
import Login from "./components/Login";

import DashboardAnalitica from "./components/Graphics";
import AmoSyncPage from "./components/AmoSyncPage";
import PrivacyPolicy from "./components/privacyPolicy";

import Logout from "./components/Logout";
import Footer from "./components/footer";
import NavbarMenu from "./components/NavbarMenu";


import CookieConsent from "./components/modals/cookie";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="page-wrap">
          <NavbarMenu />
          <main className="page-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<PrivateRoute roles={["admin", "manager"]} />}>
                <Route path="/admin/partners" element={<AdminPartners />} />
                <Route path="/admin/partner/:uniqueId" element={<AdminPartnerOrders />} />
                <Route path="/admin/analytics/overview" element={<DashboardAnalitica />} />
                <Route path="/admin/sync/amocrm" element={<AmoSyncPage />} />
                <Route path="/admin/orders" element={<OrderList />} />
              </Route>
              <Route element={<PrivateRoute roles={["admin", "manager", "partner"]} />}>
                <Route path="/partner/:uniqueId" element={<PartnerOrders />} />
              </Route>
              <Route path="/" element={<Navigate to="/admin/partners" replace />} />
              <Route path="/dashboard" element={<Navigate to="/admin/partners" replace />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/logout" element={<Logout />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <CookieConsent />
      </Router>
    </AuthProvider>
  );
}

export default App;
